import { PROFILE_IMAGE_BASE } from "../../config/env";

const ProfileImageMd = (props) => {
  const { imgSrc } = props;
  return <img className="avatar" src={PROFILE_IMAGE_BASE + imgSrc} alt="" />;
};

export default ProfileImageMd;
